export default __webpack_public_path__ + "assets/images/Copy-873f3faf69b991b252ac20dbb03b3437.svg";